import { Box, useTheme } from '@mui/material';
import React from 'react';
import { useAddNotes } from '../../../../hooks/useAddNotes';
import { useTranslation } from 'react-i18next';
import SubmitButton from '../../../commonComponents/SubmitButton';
import CustomFormInput from '../../../commonComponents/CustomFormInput';

const AddNotesForm = ({ id, handleDrawerClose }) => {
  const { t } = useTranslation();
  const { handleSubmit, control, onSubmit } = useAddNotes(id, handleDrawerClose);

  const theme = useTheme();
  const activeBg = theme.palette.secondary.main;
  const hoverBg = theme.palette.secondary.main + 'CC';

  return (
    <Box component="form" display="flex" flexDirection="column">
      <CustomFormInput name="note" control={control} label={t('Notes')} />
      <SubmitButton
        onClick={handleSubmit(onSubmit)}
        buttonText={t('Add')}
        backgroundColor={activeBg}
        hoverBgColor={hoverBg}
        color="inherit"
      />
    </Box>
  );
};

export default AddNotesForm;
